// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performance-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.65em;
}

.performance {
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
}

.user-performance {
  height: 35px;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  width: 100%;
}

.red-performance {
  background-color: #f35870;
  color: white;
}

.yellow-performance {
  background-color: #fffc39;
  color: black;
}

.green-performance {
  background-color: #7ec681;
  color: white;
}

.row-align-center {
  display: flex;
  justify-content: center;
  align-items: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
